import { FiSearch } from "react-icons/fi";
import { useState } from "react";

const ACTIVITY_TYPES = [
  { id: 1, label: "Enterprise" },
  { id: 2, label: "Site" },
];

const ActivitiesToolbar = ({
  setSearchActivity,
  clientTypeId = 1,
  setClientTypeId,
}) => {
  const [searchActivity, setSearchActivityState] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchActivityState(value);
    setSearchActivity(value);
  };

  return (
    <div className="flex flex-wrap items-center gap-4 mb-4">
      <div className="relative">
        <FiSearch
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          placeholder="Search activities"
          className="border pl-9 pr-3 py-2 rounded text-sm input-field"
          value={searchActivity}
          maxLength={256}
          onChange={handleSearchChange}
        />
      </div>

      <div className="flex items-center gap-4" role="radiogroup" aria-label="Activity type">
        {ACTIVITY_TYPES.map((type) => (
          <label
            key={type.id}
            className="flex items-center gap-2 text-sm cursor-pointer select-none"
          >
            <input
              type="radio"
              name="activityClientType"
              className="accent-primary w-4 h-4"
              value={type.id}
              checked={Number(clientTypeId) === type.id}
              onChange={() => setClientTypeId?.(type.id)}
            />
            <span>{type.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ActivitiesToolbar;
